import { Empty } from 'antd';
import sortBy from 'lodash/sortBy';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { Rating as RatingT } from 'api/reports/csat';
import { RATING_COLOR_HASH } from '../../utils';
import { Widget } from '../widget';
import { Chart } from './chart';

const series = [
  {
    type: 'pie',
    colorByPoint: true,
  },
];

interface Props {
  data?: RatingT[];
  isLoading?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 184px;
`;

export const Ratings: FC<Props> = (props) => {
  const { data = [], isLoading } = props;
  const intl = useIntl();
  const getData = (_data) => {
    let seriesData: { y: number; name: string; color: string }[] = [];

    seriesData = sortBy(_data, 'rating').map((d) => ({
      y: d.count,
      name: intl.formatMessage({ id: `csat.rating.${d.rating}` }),
      color: RATING_COLOR_HASH[d.rating],
    }));

    return {
      ...series,
      type: 'pie',
      name: intl.formatMessage({ id: 'count' }),
      data: seriesData,
    };
  };

  return (
    <Widget
      loading={isLoading}
      title={<FormattedMessage id="csat.widget.heading.by_ratings" />}
    >
      {data.length > 0 ? (
        <Container>
          <Chart series={getData(data)} />
        </Container>
      ) : (
        <Empty />
      )}
    </Widget>
  );
};
